module.exports = __webpack_public_path__ + "img/play.72c50854.svg";